/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EvaluationType } from './EvaluationType';
import {
    instanceOfEvaluationType,
    EvaluationTypeFromJSON,
    EvaluationTypeFromJSONTyped,
    EvaluationTypeToJSON,
} from './EvaluationType';

/**
 * @type CreateNumericEvaluationParameterDtoEvaluationType
 * 
 * @export
 */
export type CreateNumericEvaluationParameterDtoEvaluationType = EvaluationType;


export function CreateNumericEvaluationParameterDtoEvaluationTypeFromJSON(json: any): CreateNumericEvaluationParameterDtoEvaluationType {
    return CreateNumericEvaluationParameterDtoEvaluationTypeFromJSONTyped(json, false);
}

export function CreateNumericEvaluationParameterDtoEvaluationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNumericEvaluationParameterDtoEvaluationType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...EvaluationTypeFromJSONTyped(json, true) };
    return  EvaluationTypeFromJSONTyped(json, true);
}

export function CreateNumericEvaluationParameterDtoEvaluationTypeToJSON(value?: CreateNumericEvaluationParameterDtoEvaluationType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfEvaluationType(value)) {
        return EvaluationTypeToJSON(value as EvaluationType);
    }

    return {};
}

/**
 * Check if a given object implements the CreateNumericEvaluationParameterDtoEvaluationType interface.
 */
export function instanceOfCreateNumericEvaluationParameterDtoEvaluationType(value: any): value is CreateNumericEvaluationParameterDtoEvaluationType {
    if (instanceOfEvaluationType(value)) return true;
    return false;
}

